import React from 'react';
import LoadOutFunctional from './components/load-out-functional';
import './load-out.scss';

const LoadOut = () => {
	return <LoadOutFunctional />;
};

export default LoadOut;
